import { useLayoutEffect, useMemo } from "react"
import { getData } from "./api"
import useFetchItemById from "../../../../queries/useFetchItemById"

export default function useBCAResource({id, method = 'view'}){

    const {
        data: batchData,
        fetchData: fetchBatchData,
        isLoading: isFetchingBatch,
    } = useFetchItemById({ fetcher:  getData, moduleName: method, payLoad: {} })

    const isLoadingResources = useMemo(() => {
        return isFetchingBatch === true
    }, [
        isFetchingBatch
    ])
    

    useLayoutEffect(()=>{fetchBatchData({id: id})}, [fetchBatchData])

    return {
        id,
        batchData,
        isFetchingBatch,
        fetchBatchData,
        isLoadingResources
    }
}